export default {"src":"/_next/static/media/snapp-pay-blue.86388ec6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};